import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';

type State = {
  requesting: boolean;
};

const initialState: State = {
  requesting: false,
};

const requestingSlice = createSlice({
  name: 'requesting',
  initialState,
  reducers: {
    updateIsRequesting(state: State, action: PayloadAction<boolean>) {
      state.requesting = action.payload;
    },
  },
});

export const { updateIsRequesting } = requestingSlice.actions;

export const selectRequesting = (state: RootState) => state.requesting.requesting;

export default requestingSlice.reducer;
